import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import {
  EmployeeEnterUserScreen,
  EmployeeIssueVoucherHistoryScreen,
  EmployeeIssueVoucherScreen,
  EmployeeLoginScreen,
  EmployeeMenuScreen,
  EmployeeUploadScreen,
} from "screens"
import { colors } from "colors"
import { translate } from "i18n"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import { useStores } from "models"
import { useColor } from "app/theme/getThemes"

export type EmployeeParamList = {
  employeeLogin: undefined
  employeeUploadReceipt: undefined
  employeeIssueVoucher: undefined
  employeeIssueVoucherHistory: undefined
  employeeMenu: undefined
}
const Stack = createStackNavigator<EmployeeParamList>()

export const EmployeeStack = () => {
  const { userStore } = useStores()
  const { companyTheme } = useColor()

  return (
    <Stack.Navigator
      initialRouteName={userStore?.accessToken ? "employeeMenu" : "employeeLogin"}
      screenOptions={{
        headerShown: false,
        headerStyle: {
          backgroundColor: companyTheme.first,
        },
        headerBackImage: () => <MaterialIcons name="chevron-left" color="white" size={42} />,
        headerBackTitleVisible: false,
        headerTitleAlign: "center",
        headerTitleStyle: {
          color: "white",
        },
        headerTintColor: "white",
        cardStyle: { flex: 1 },
      }}
    >
      <Stack.Screen
        name="employeeLogin"
        component={EmployeeLoginScreen}
        options={{
          headerTitle: translate("employeeLoginScreen.title"),
        }}
      />
      <Stack.Screen
        name="employeeUploadReceipt"
        component={EmployeeUploadScreen}
        options={{
          headerTitle: translate("employeeLoginScreen.title"),
        }}
      />
      <Stack.Screen
        name="employeeIssueVoucher"
        component={EmployeeIssueVoucherScreen}
        options={{
          headerTitle: translate("employeeLoginScreen.title"),
        }}
      />
      <Stack.Screen
        name="employeeIssueVoucherHistory"
        component={EmployeeIssueVoucherHistoryScreen}
        options={{
          headerTitle: translate("employeeLoginScreen.title"),
        }}
      />
      <Stack.Screen name="employeeMenu" component={EmployeeMenuScreen} />
      <Stack.Screen name="employeeEnterUser" component={EmployeeEnterUserScreen} />
    </Stack.Navigator>
  )
}
